import * as fromDatatype from '../datatype-library/index';

export class bl_inv_bin_marking_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_code: fromDatatype.VarcharDatatypeInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_code: fromDatatype.VarcharDatatypeInterface;
  packing_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
  index_offset: fromDatatype.NumericDatatypeInterface;
  sequence: fromDatatype.NumericDatatypeInterface;
  direction: fromDatatype.VarcharDatatypeInterface;
  qty_limit: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_bin_marking_RowClass implements bl_inv_bin_marking_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_code: fromDatatype.VarcharDatatypeInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_code: fromDatatype.VarcharDatatypeInterface;
  packing_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
  index_offset: fromDatatype.NumericDatatypeInterface;
  sequence: fromDatatype.NumericDatatypeInterface;
  direction: fromDatatype.VarcharDatatypeInterface;
  qty_limit: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}